export enum VatRegime {
	NORMAAL = 1,
	BTW_MEDECONTRACTANT = 2,
	VERKOOP_AAN_ANDERE_LIDSTATEN_BINNEN_DE_EG = 3,
	VERKOOP_BUITEN_DE_EG = 4,
	TRANSPORT_ONDER_T_DOCUMENT = 5,
	VRIJ_VAN_BTW = 6,
	BTW_OP_2DE_HANDS_VERKOPEN = 7,
	ANDERE_VOOR_VAK_47 = 8,
	DIENSTEN_AAN_ANDERE_LIDSTATEN_BINNEN_DE_EG = 9,
	DIENSTEN_BUITEN_DE_EG = 10,
	BTW_MEDECONTRACTANT_BINNEN_DE_EG_44 = 11,
	AAN_0 = 12,
	AAN_6 = 13,
	AAN_12 = 14,
	AAN_21 = 15,
	AAN_6_BTW_RENOVATIE = 16,
	VRIJSTELLING_WBTW = 17,

	//Vrijstelling van BTW volgens artikel 42, §1 eerste lid 2° WBTW.

}

export function getVatRegimes():number[] {
	return [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17];
}